export const SET_TEST_CLICK = 'setTestClick';
export const SET_TEST_DATA = 'setTestData';
export const  SET_TEST_VALUE = 'setTestValue';


export const setTestClick = () => ({
    type: SET_TEST_CLICK
});

export const setTestData = data => ({
    type: SET_TEST_DATA,
    data
});

export const setTestValue = value => ({
    type: SET_TEST_VALUE,
    value
});